<header class="main__content__header modal-header">
  <h2 class="modal-title">Detalhes Médico Hospitalar - {{details.code}}</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <section class="modal__main__dados_usuario content__modal__header">
    <div class="pl-0 pr-0 mb-3 row blc-info">
      <div class="col-12 mb-1">
        <span class="content__modal__title">Prestador</span>
        <p class="content__modal__valor">{{details.provider}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Beneficiário</span>
        <p class="content__modal__valor">{{details.cpf}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Número da Guia</span>
        <p class="content__modal__valor">{{details.code}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Data do Procedimento</span>
        <p class="content__modal__valor">{{details.serviceDate | date: 'dd/MM/yyyy'}}</p>
      </div>
    </div>
    <div class="col-12 mb-3 pl-0 pr-0 row">
      <div class="col-4">
        <span class="content__modal__title">Data do Pagamento</span>
        <p class="content__modal__valor">{{details.paymentDate | date: 'dd/MM/yyyy'}}</p>
      </div>
      <div class="col-4">
        <span class="content__modal__title">Valor Pago</span>
        <p class="content__modal__valor">{{details.totalValue | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-4">
        <span class="content__modal__title">Valor Coparticipação</span>
        <p class="content__modal__valor">{{details.coparticipationValue | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
    </div>
  </section>
</main>
<footer class="mb-2">
  <section class="content__resultado__grid__main">
    <section class="content__header__table">
      <div class="col-6">Descrição</div>
      <div class="col-4">Coparticipação</div>
      <div class="col-2">Valor Total</div>
    </section>
    <section class="content__main__table">
      <div class="table__card" *ngFor="let procedimento of details.healthFinancialProcedures; let firstItem = first">
        <div class="col-6">{{procedimento.description}}</div>
        <div class="col-4">{{procedimento.coparticipationValue | currency:'BRL':'symbol':'1.2-2':'pt'}}</div>
        <div class="col-2">{{procedimento.totalValue | currency:'BRL':'symbol':'1.2-2':'pt'}}</div>
      </div>
    </section>
  </section>
</footer>